<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar color="light-blue" dark>
            <v-toolbar-title>Public Projects</v-toolbar-title>
          </v-toolbar>
          <v-data-table :headers="publicProjectsHeaders" :items="publicProjects" :pagination.sync="pagination" class="elevation-5">
            <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" style="max-width: 10px">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.ownerUsername }}</td>
              <td class="text-xs-left">
                <v-tooltip top>
                  <span slot="activator" class="text-xs-left">{{ formatDateRelative(props.item.updatedAt) }}</span>
                  <span>{{ formatDateAbsolute(props.item.updatedAt) }}</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">
                <v-tooltip top>
                  <span slot="activator" class="text-xs-left">{{ formatDateRelative(props.item.createdAt) }}</span>
                  <span>{{ formatDateAbsolute(props.item.createdAt) }}</span>
                </v-tooltip>
              </td>              
              <td class="layout">
                <v-btn icon class="mx-0" title="Open Project" @click="openProject(props.item)"><v-icon color="blue">open_in_browser</v-icon></v-btn>
                <v-btn icon class="mx-0" title="Duplicate Project" @click="duplicateProject(props.item)"><v-icon color="amber">file_copy</v-icon></v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  import moment from 'moment'
  export default {
    data: () => ({
      publicProjects: [],
      publicProjectsHeaders: [
        {text: 'Name', value: 'name', align: 'left', sortable: true, width: '40%'},
        {text: 'Owner', value: 'owner', align: 'left', sortable: true},
        {text: 'Modified', value: 'updatedAt', align: 'left', sortable: true},
        {text: 'Created', value: 'createdAt', align: 'left', sortable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false, class: 'column-wrap'}
      ],
      pagination: {
        'sortBy': 'updatedAt',
        'descending': true,
        'rowsPerPage': 25
      },
    }),
    methods: {
      refreshProjects () {
        EventBus.$emit('start-loading');
        this.$http.get(this.$store.state.serverHttpUrl+'/publicprojects').then(
          function(response) {
            this.publicProjects = response.data;
            EventBus.$emit('stop-loading');
          }, function (err) {
            EventBus.$emit('stop-loading');
            EventBus.$emit('send-notification', {text: 'Error fetching projects ('+err+')'});
        });
      },
      duplicateProject(item) {
        this.$http.post(this.$store.state.serverHttpUrl+'/project', {
          name: item.name + ' (copy)',
          ownerEmail: this.$store.state.email,
          ownerUsername: this.$store.state.user,
          privacy: item.privacy,
          saveFile: item.saveFile
        }).then(function (response) {
          EventBus.$emit('send-notification', {text: 'Project duplicated successfully', color: 'success'});
          this.refreshProjects();
        }, function (err) {
          EventBus.$emit('send-notification', {text: 'Error duplicating project ('+err+')'});
        })
      },
      openProject(item) {
        this.$store.dispatch('setCurrentProjectName', item.name);
        this.$store.dispatch('setCurrentProjectId', item._id);
        this.$router.push('/workspace');
      },
      formatDateRelative(date) {
        return moment(date).fromNow();
      },
      formatDateAbsolute(date) {
        return moment(date).format("dddd, MMMM Do YYYY, HH:mm:ss");
      },
    },
    created () {
      this.refreshProjects()
    }
  }
</script>

<style>
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .column-wrap {
    width: 1px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicProjects/PublicProjects.vue